export class Modal {
  constructor({
    modalKey = 'modal',
    modalClass = '.c-modal',
    showClass = 'is-show',
    hideClass = 'is-hide',
    closeClass = '.c-modal__close',
    backdropClass = '.c-modal__backdrop',
    onInit = () => {},
    onShow = () => {},
    onHide = () => {}
  } = {}) {
    this.modalKey = modalKey;
    this.modalClass = modalClass;
    this.showClass = showClass;
    this.hideClass = hideClass;
    this.closeClass = closeClass;
    this.backdropClass = backdropClass;
    this.onInit = onInit;
    this.onShow = onShow;
    this.onHide = onHide;

    // Add a popstate event listener
    window.addEventListener('popstate', (event) => {
      const modalId = event.state && event.state.modalId;
      if (modalId) {
        const modalElement = document.querySelector(`${this.modalClass}[data-${this.modalKey}="${modalId}"]`);
        if (modalElement && modalElement.style.display === 'block') {
          this.hide(modalElement);
          this.onHide(modalElement);
        }
      } else {
        // If all modals should be closed when going back
        const allModalElements = document.querySelectorAll(`${this.modalClass}.${this.showClass}`);
        allModalElements.forEach((modalElement) => {
          this.hide(modalElement);
          this.onHide(modalElement);
        });
      }
    });

    this.init();
  }

  init() {
    try {
      const triggerElements = document.querySelectorAll(`[data-${this.modalKey}-trigger]`);
      triggerElements.forEach(element => {
        const modalId = element.getAttribute(`data-${this.modalKey}-trigger`);
        const modalElement = document.querySelector(`${this.modalClass}[data-${this.modalKey}="${modalId}"]`);

        if (modalElement === null) throw new Error(`モーダル初期化に失敗: data-${this.modalKey}が見つからない`);

        const closeElement = modalElement.querySelector(this.closeClass);
        const backdropElement = modalElement.querySelector(this.backdropClass);

        this.onInit(modalElement);

        element.addEventListener('click', () => {
          // Push a new state when opening the modal
          history.pushState({modalId}, '');
          this.show(modalElement);
          this.onShow(modalElement);
        });
        closeElement.addEventListener('click', () => {
          // Go back in history when closing the modal
          history.back();
        });
        backdropElement.addEventListener('click', () => {
          // Go back in history when closing the modal
          history.back();
        });

        modalElement.addEventListener('animationend', () => {
          if (modalElement.classList.contains(this.hideClass)) {
            modalElement.style.display = 'none';
          }
        });
      });
    } catch (error) {
      console.error(`Failed to initialize modal: ${error}`);
    }
  }

  show(modalElement) {
    modalElement.style.display = 'block';
    modalElement.classList.remove(this.hideClass);
    modalElement.classList.add(this.showClass);
  }

  hide(modalElement) {
    modalElement.classList.remove(this.showClass);
    modalElement.classList.add(this.hideClass);
  }
}
